import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import * as api from './api';

const appInfoKey = ['app-info'] as const;

export function useAppInfo() {
  return useQuery({ queryKey: appInfoKey, queryFn: api.getAppInfo, staleTime: 5 * 60_000 });
}

export function useUpdateDepartment() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (department: string) => api.updateDepartment(department),
    onSuccess: () => qc.invalidateQueries({ queryKey: appInfoKey }),
  });
}
